var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-logout",
    width: 25,
    height: 22,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAYAAAA1vze2AAABkElEQVRIib3VMUhXURTH8Y/1jyjSoESooQJdzDXSJQQHJwnKoaGabG0Il1YhgoYiWhoUh7BoK4gIhSJKB5fGEreGBgc3KTKiuH+OcCPf8/7V+sHjcM+7533fuffcc9s8nhXqxCiOqdcvLOEZ1reY21Qj7Fm8wpGSoNBHDGGlBLIHTwKQ/vILftbEHEAXTuMurpRA+tAd42uYLshiCmM4XzC3mcXRbPyhJAjzYdtLIf9c24V8C/s18w1gBmd2K5PnuImLmS+NL+M1+ncD8h13MJv5HuIHOjCXgxqbf6OpHhxqAZzOyy1MZKBhLFZBUilPtgDYTB2R6amq5dq3Q8CGUhJ7qzJJ6/sW+1v86FB0AVGB6bCu1u3JpxYB52JPNgAjeGMH1ZWW8zoGM9949LU/ALaorjpdwAOsZa3lXpTwfSzksduFHAybl/i7eP7Sf+tdq9m4rzBuIOxayeRG3HCfcRKPcDsuryqlTT8e716WQtIteBUvcBgnCrNZxo1SSNJ79OJSQOr2KlVQyv5p1vKrhd/Py0OeyCXfQwAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.b289a2e8.svg";
export { ForwardRef as ReactComponent };